<template>
  <div class="row dayselector">
    <div class="small-12 medium-2 large-1 columns selweek hide-for-small-only">
      <a @click="weekswipper.swiper.slidePrev()"
        :class="{'disabled': activeIndex == 0}">
        <i class="fa fa-chevron-left"></i>
      </a>
    </div>
    <div class="small-12 medium-8 large-10 columns">
      <div id="dayselectornn">
        <swiper-container
          ref="weekswipper"
          class="swiper-container"
          :initialSlide="weeks.length"
          :centered-slides="true"
          :slides-per-view="1">
          <swiper-slide :key="weeki" v-for="weeki in weeks">
            <div class="row week">  
              <div class="small-4 medium-4 large-2 columns dia"
                :class="{'active': isActiveDay(dia.cday)}"
                @click="setCurrentDay(dia.cday)"
                v-for="dia in weeki">
                  <span class="day">{{dia.day}}</span>
                  <span class="mes">{{dia.month}}</span>
                  <span class="weekday">{{dia.diaweek}}</span>
                  <span class="weekdaymobile">{{dia.diaweekmobile}}</span>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
    <div class="small-12 medium-2 large-1 columns selweek hide-for-small-only">
      <a @click="weekswipper.swiper.slideNext()"
        :class="{'disabled': activeIndex== 4}">
        <i class="fa fa-chevron-right"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { i18n } from "@/main.js";
import { register } from 'swiper/element/bundle';
register();

import 'swiper/css';

export default {
  props:["currentDay"],
  setup (props, { emit }) {
    
    const weeks = ref([]);
    const lang = i18n.global.locale;
    const rcalendar = ref([]);

    const generateCalendar = () => {
      const today = new Date();
      const lweek = new Date(today);
      lweek.setDate(lweek.getDate() - lweek.getDay() - 28); 
      
      const diff = Math.floor((today - lweek) / (24 * 60 * 60 * 1000)); 
      rcalendar.value = [];

      [...Array(diff).keys()].forEach(el => {
        const cdata = new Date(today);
        cdata.setDate(today.getDate() - (diff - el));
        if (cdata.getDay() !== 0) {
          rcalendar.value.push(cdata);
        }
      });

      const currentDay = today.getDay();
      for (let i = currentDay; i < 7; i++) {
        const nextDay = new Date(today);
        nextDay.setDate(today.getDate() + (i - currentDay));
        rcalendar.value.push(nextDay);
      }

      weeks.value = rcalendar.value.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / 6);
        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [];
        }
        const dayFormatter = new Intl.DateTimeFormat(lang, { day: '2-digit' });
        const monthFormatter = new Intl.DateTimeFormat(lang, { month: 'long' });
        const weekdayFormatter = new Intl.DateTimeFormat(lang, { weekday: 'long' });
        const weekdayShortFormatter = new Intl.DateTimeFormat(lang, { weekday: 'short' });
        var formattedItem = {
          cday: item,
          day: dayFormatter.format(item),
          month: monthFormatter.format(item),
          diaweek: weekdayFormatter.format(item),
          diaweekmobile: weekdayShortFormatter.format(item)
        };
        resultArray[chunkIndex].push(formattedItem);
        return resultArray;
      }, []);
    }

    generateCalendar()

    const currentDay = ref(new Date());

    const isActiveDay = date => date.getDay() == currentDay.value.getDay();

    const setCurrentDay = day => {
      currentDay.value = day;
      emit("selectedDay",day)
    }

    const weekswipper = ref(null);
    const activeIndex = ref(4)

    const updateActiveIndex = () => {
      activeIndex.value = weekswipper.value.swiper.activeIndex;
    };

    onMounted(() => {
      weekswipper.value.swiper?.on('slideChange', () => {
        updateActiveIndex();
        const current = weeks.value[activeIndex.value];
        emit('updatedWeek',{start:current[0].cday,end:current[5].cday})

      })
    })
    
    return {
      activeIndex,
      weekswipper,
      weeks,
      isActiveDay,
      setCurrentDay
    }
  }
}
</script>

<style lang="scss" scoped>
.week .dia{
   box-sizing: border-box;
}

.dayselector .selweek{
  display: flex;
  align-items: center;
  padding-right: 0;
  padding-left: 0;
}

.dayselector .selweek i{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #06546bd1;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dayselector .selweek a.disabled i{
  background: #f0f0f3;
}

.dayselector .selweek:last-of-type{
  display: flex;
  flex-direction: row-reverse;
}

.dayselector .dia{
  display: flex;
  flex-direction: column;
  background-clip: content-box;
  background-color: #f0f0f3;
  padding: 8px;
  border-radius: 25px;
  font-family: Montserrat;
}

.dayselector .dia.active{
  background-color: #dcdddfeb;
}

.dayselector .dia.active .day {
  font-size: 30px;
}

.dayselector .dia .day {
  font-size: 25px;
  margin-bottom: 5px;
}

.dayselector .dia:hover{
    cursor: pointer;
}

.dayselector .dia {
  color: #333333;
  font-size: 19px;
}

.dayselector .dia .day {
  font-size: 25px;
  margin-bottom: 5px;
}

.dayselector .dia span{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 19px;
  color: #333333;
  text-transform: capitalize;
}

.dia span:first-of-type{
  padding-top: 25px;
}

.dia span.weekdaymobile {
  display: none;
}

.dia span.weekday{
  font-size: 16px;
  color: #6eb7ec;
  padding-bottom: 35px;
}

@media (max-width: 767px) {
  .mobile.dayselector{
    display: flex;
  }

  .mobile.dayselector .dia .day,
  .mobile.dayselector .dia .weekday{
    font-size: 16px;
  }

  .mobile.dayselector .dia .mes{
    font-size: 16px;
  }

  .ementalist .dayselector .dia span{
    font-size: 14px;
  }
  .ementalist .dayselector .dia span.day{
    font-size: 20px;
  }

  .dia span:last-of-type {
    padding-bottom: 15px;
  }

  .ementalist .dayselector .dia .day {
    margin-bottom: 0px;
  }

  .ementalist .dayselector .dia.active .day {
    font-size: 20px;
    font-family: "Montserrat Bold";
  }

  .dia span:first-of-type {
    padding-top: 15px;
  }
  
}
</style>